import { registerTaskComparitor } from "routes/schedule/compare/register-task-comparitor"
import { Bound } from "lib/@components/binding/Bound"
import { useState } from "react"
import { DifferenceWrapper } from "routes/schedule/compare/differenceWrapper"
import { Box, useTheme } from "@mui/material"
import { DifferenceTitle } from "routes/schedule/compare/difference-title"
import { ListItemBox } from "lib/@components/ListItemBox"
import { Status } from "routes/schedule/compare/status"
import { Classification } from "routes/schedule/tasks/classification"
import { Editable } from "lib/@components/editable"
import { PropertyBox } from "lib/@components/property-box"
import { EditModeSwitch } from "routes/schedule/compare/edit-mode-switch"
import { Approved } from "routes/schedule/compare/approved"
import { BoundPopup } from "lib/@components/combos/boundPopup"
import { VALID_CLASSIFICATIONS } from "library/SFG20/constants.mjs"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { useBoundValue } from "lib/@components/binding/use-bound-value"

registerTaskComparitor("classification", () => <ClassificationChange label="criticality" />, true)

export function ClassificationChange({ label }) {
    const { target, to } = useBoundContext()
    const [value, setValue] = useBoundValue("classification")
    const [original] = useState(value)
    const [copied, setCopied] = useState(false)
    const [hover, setHover] = useState(false)
    const theme = useTheme()

    if (!to?.classification || !target?.classification) {
        return "Missing a classification"
    }
    return (
        <DifferenceWrapper label={`${target.title}: ${label}`}>
            <PropertyBox ml={-1}>
                <DifferenceTitle label={label} />
                <ListItemBox alignItems="center">
                    <Box
                        flex={1}
                        sx={{ pl: 1, opacity: hover ? 0.25 : 1, transition: "opacity 0.2s linear", mr: -1 }}
                        data-cy="classification-change-left"
                    >
                        <EditModeSwitch>
                            <Bound task={target}>
                                <Box py={1}>
                                    <Editable
                                        p={0.5}
                                        field="classification"
                                        editor={
                                            <BoundPopup
                                                aria-label="Classification"
                                                field="classification"
                                                sx={{ my: -0.6, ml: -0.6 }}
                                                contentProps={{ pt: 1 }}
                                                options={VALID_CLASSIFICATIONS}
                                            >
                                                <Classification classification={target.classification}>
                                                    {target.classification.titleize()}
                                                </Classification>
                                            </BoundPopup>
                                        }
                                    >
                                        <Classification classification={target.classification}>
                                            {target.classification.titleize()}
                                        </Classification>
                                    </Editable>
                                </Box>
                            </Bound>
                        </EditModeSwitch>
                    </Box>
                    <Approved id={target.id}>
                        <Status
                            onHover={setHover}
                            onCopyChanged={setCopied}
                            copy={copy}
                            path="classification"
                            revert={revert}
                        />

                        <Box
                            flex={1}
                            sx={{
                                opacity: copied ? 0.5 : 1,
                                borderRadius: 1,
                                transition: "background-color linear 0.2s",
                                bgcolor: hover ? `${theme.palette.primary.main}20` : undefined,
                            }}
                            data-cy="classification-change-right"
                        >
                            <Bound target={to} task={to} editMode={false}>
                                <Box lineHeight={1}>
                                    <Editable
                                        p={0.5}
                                        field="classification"
                                        editor={
                                            <BoundPopup
                                                contentProps={{ pt: 1 }}
                                                aria-label="Classification"
                                                field="classification"
                                                options={VALID_CLASSIFICATIONS}
                                            >
                                                <Classification classification={to.classification}>
                                                    {to.classification.titleize()}
                                                </Classification>
                                            </BoundPopup>
                                        }
                                    >
                                        <Classification classification={to.classification}>
                                            {to.classification.titleize()}
                                        </Classification>
                                    </Editable>
                                </Box>
                            </Bound>
                        </Box>
                    </Approved>
                </ListItemBox>
            </PropertyBox>
        </DifferenceWrapper>
    )

    function copy() {
        setValue(to.classification)
    }

    function revert() {
        setValue(original)
    }
}
